import gql from 'graphql-tag';

export default gql`
  fragment formPostOtherNumberFragment on FormPostOtherNumber {
    id
    value
    formBlockFieldOtherId
    createdAt
    updatedAt
  }
`;


